import React, { useContext, useState, useEffect } from "react";
import { Dialog, List, SwipeAction, Toast } from "antd-mobile";
import { Col, Form, Row, Card } from "react-bootstrap";
import axios from "axios";
import $ from "jquery";
import PsContext from "../../context";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import WelcomeProfile from "../home/welcomeProfile";
import { useParams } from "react-router-dom";
import { unitless } from "antd/es/theme/useToken";

const TargetSettings = (props) => {
  const context = useContext(PsContext);
  const [viewData, setViewData] = useState([]);
  const [targetMark, setTargetMark] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    loadTargetMarks();
    loadSubjects();
  }, []);

  const loadSubjects = () => {
    context.setLoader(true);
    const form = new FormData();
    form.append("course", context.user.course);
    form.append("academic_year", context.user.academicyear);
    form.append("semester", context.user.semester);

    axios.post(ServiceUrl.STUDENTS.LIST_CURRENT_SUBJECTS, form).then((res) => {
      if (res["data"].status === "1") {
        setViewData(res["data"].data);
        console.log("res", res);
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }
      context.setLoader(false);
    });
  };
  console.log("context.user.", context.user);

  const loadTargetMarks = () => {
    context.setLoader(true);
    const form = new FormData();
    form.append("student_uuid", context.user.uuid);
    form.append("batch", context.user.batch);
    axios.post(ServiceUrl.STUDENTS.LIST_TARGET_MARK, form).then((res) => {
      if (res["data"].status === "1") {
        setTargetMark(res["data"].data);
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }
      context.setLoader(false);
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      return;
    }

    if (!window.confirm("Do you want to save?")) {
      return;
    }

    setLoader(true);
    axios
      .post(
        ServiceUrl.STUDENTS.SAVE_SUBJECT_TARGET_MARK,
        $("#frm_target").serialize()
      )
      .then((res) => {
        if (res["data"].status === "1") {
          if (props.onSuccess) props.onSuccess();
          Toast.show({ content: res["data"].message || "Saved" });
          loadTargetMarks();
        } else {
          Toast.show({ content: res.data.message || "Error" });
        }
        setLoader(false);
      });
  };

  const handleRadioChange = (id, value) => {
    setTargetMark((prevTargetMark) =>
      prevTargetMark.map((mark) =>
        mark.subject_id === id ? { ...mark, subject_status: value } : mark
      )
    );
  };

  return (
    <>
      <Header title="Target Mark" backAction={true} />
      <div className="page-content-wrapper">
        <div className="container py-3 px-2">
          <WelcomeProfile />

          {/* Form */}
          <Form
            method="post"
            noValidate
            id="frm_target"
            onSubmit={handleFormSubmit}
          >
            {/* Hidden inputs */}
            <input
              type="hidden"
              name="student_uuid"
              value={context.user.uuid}
            />
            <input
              type="hidden"
              name="semester"
              value={context.user.semester}
            />
            <input type="hidden" name="batch" value={context.user.batch} />
            <input type="hidden" name="section" value={context.user.section} />

            {/* Semester & Section Card */}
            <Card className="mb-3 shadow-sm border-0">
              <Card.Body>
                <Row className="align-items-center">
                  <Col md={2}>
                    <Card.Title className="text-muted">Semester</Card.Title>
                  </Col>
                  <Col md={3}>
                    <Card.Text className="fw-bold text-dark">
                      {context.user.semester} Sem
                    </Card.Text>
                  </Col>

                  <Col md={2}>
                    <Card.Title className="text-muted">Section</Card.Title>
                  </Col>
                  <Col md={3}>
                    <Card.Text className="fw-bold text-dark">
                      {context.user.section}
                    </Card.Text>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* Target Marks Card */}
            <Card
              className="shadow-sm border-0"
              style={{ backgroundColor: "#ffffff" }}
            >
              <Card.Body>
                {viewData
                  .filter(
                    (course) =>
                      course.subject_code !== "DAME001" &&
                      course.subject_code !== "SUBS001" &&
                      course.subject_code !== "LIB001" &&
                      course.subject_code !== "SE001" &&
                      !course.subject_name.startsWith("MENTOR -")
                  )
                  .map((course, index) => (
                    <Row key={course.id} className="align-items-center mt-3">
                      <Col md={6}>
                        <Form.Control
                          type="text"
                          className="fw-bold text-secondary"
                          value={`${course.subject_name} - ${course.subject_code}`}
                          readOnly
                          style={{
                            background: "#f7f9fc",
                            padding: "10px 0",
                            border: "none",
                          }}
                        />
                        <input
                          type="hidden"
                          name="subject_id[]"
                          value={course.id}
                        />
                      </Col>

                      <Col md={6}>
                        {targetMark &&
                          targetMark.length > 0 &&
                          (targetMark.find(
                            (mark) => mark.subject_id === course.id
                          )?.subject_mark === undefined ? (
                            <Form.Control
                              type="text"
                              className="fw-bold text-dark"
                              size="sm"
                              name={`subject_mark[${course.id}]`}
                              placeholder="Enter target marks"
                              /* value={
                              targetMark.find(
                                (mark) => mark.subject_id === course.id
                              )?.subject_mark !== undefined
                                ? targetMark.find(
                                    (mark) => mark.subject_id === course.id
                                  ).subject_mark
                                : ""
                            } */
                              onInput={(e) => {
                                const value = e.target.value.replace(/\D/g, "");
                                if (value.length <= 3) {
                                  e.target.value = value;
                                }
                              }}
                              inputMode="numeric"
                              pattern="\d{1,3}"
                              maxLength="3"
                              style={{ padding: "5px", borderColor: "#007bff" }}
                            />
                          ) : (
                            <>
                              <Form.Control
                                type="text"
                                className="fw-bold text-dark"
                                size="sm"
                                name={`subject_mark[${course.id}]`}
                                placeholder="Enter target marks"
                                value={
                                  targetMark.find(
                                    (mark) => mark.subject_id === course.id
                                  )?.subject_mark !== undefined
                                    ? targetMark.find(
                                        (mark) => mark.subject_id === course.id
                                      ).subject_mark
                                    : ""
                                }
                                style={{
                                  padding: "5px",
                                  background: "#f7f9fc",
                                }}
                                readOnly
                              />
                            </>
                          ))}

                        {!targetMark.length > 0 && (
                          <Form.Control
                            type="text"
                            className="fw-bold text-dark"
                            size="sm"
                            name={`subject_mark[${course.id}]`}
                            placeholder="Enter target marks"
                            /* value={
                            targetMark.find(
                              (mark) => mark.subject_id === course.id
                            )?.subject_mark !== undefined
                              ? targetMark.find(
                                  (mark) => mark.subject_id === course.id
                                ).subject_mark
                              : ""
                          } */
                            onInput={(e) => {
                              const value = e.target.value.replace(/\D/g, "");
                              if (value.length <= 3) {
                                e.target.value = value;
                              }
                            }}
                            inputMode="numeric"
                            pattern="\d{1,3}"
                            maxLength="3"
                            style={{ padding: "5px", borderColor: "#007bff" }}
                          />
                        )}
                        {context.allowedAccess(
                          "stu_mob_target_complted",
                          "action_list"
                        ) && (
                          <Form.Group className="mt-2">
                            <Form.Label className="fw-light">
                              Target Mark Completed
                            </Form.Label>

                            <Form.Check
                              inline
                              label="Yes"
                              name={`subject_status[${course.id}]`}
                              type="radio"
                              value="yes"
                              checked={
                                targetMark.find(
                                  (mark) => mark.subject_id === course.id
                                )?.subject_status === "yes"
                              }
                              onChange={() =>
                                handleRadioChange(course.id, "yes")
                              }
                            />

                            <Form.Check
                              inline
                              label="No"
                              name={`subject_status[${course.id}]`}
                              type="radio"
                              value="no"
                              checked={
                                targetMark.find(
                                  (mark) => mark.subject_id === course.id
                                )?.subject_status === "no"
                              }
                              onChange={() =>
                                handleRadioChange(course.id, "no")
                              }
                            />
                          </Form.Group>
                        )}
                      </Col>
                    </Row>
                  ))}

                {/* Submit Button */}
                <Row className="mt-4">
                  <Col className="text-center">
                    <button className="btn btn-primary px-4" disabled={loader}>
                      Save
                    </button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Form>
        </div>
      </div>
    </>
  );
};

export default TargetSettings;
